import { useState, useEffect } from 'react';
import moment from 'moment';

// material
import { DataGrid } from '@material-ui/data-grid';
import { Box, Grid, Container, Typography, LinearProgress } from '@material-ui/core';

// components
import { firestore } from '../firebase';
import Page from '../components/Page';
import Summary from '../containers/pipedrive/Summary';

// ----------------------------------------------------------------------

export default function Pagarme() {
  const transactionsCollections = firestore.collection('pagarme_transactions');
  const [transactions, setTransactions] = useState([]);
  const [filterTransactions, setFilterTransactions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const totalWithError = transactions.filter(
    (transaction) => transaction.pipedrive_processed?.case === 'Error'
  ).length;

  const totalPipedriveSuccess = transactions.filter(
    (transaction) => !!transaction.pipedrive_processed
  ).length;

  const totalNotSync = transactions.filter(
    (transaction) => !transaction.pipedrive_processed
  ).length;

  const totalTransactions = transactions.length;

  useEffect(() => {
    transactionsCollections
      .orderBy('date_updated', 'desc')
      .get()
      .then((snapshot) => {
        const transactionsRaw = snapshot.docs
          .map((doc) => doc.data())
          .filter(
            (transaction) =>
              transaction.pipedrive_processed !== undefined &&
              transaction.pipedrive_processed !== null
          );
        setTransactions(transactionsRaw);
        setFilterTransactions(transactionsRaw);
      })
      .finally(() => setIsLoading(false));
  }, []);

  const onSummaryClick = (summary) => {
    switch (summary) {
      case 'synced':
        setFilterTransactions(transactions.map((transaction) => transaction.pipedrive_processed));
        break;
      case 'waiting':
        setFilterTransactions(transactions.map((transaction) => !transaction.pipedrive_processed));
        break;
      case 'error':
        setFilterTransactions(
          transactions.map((transaction) => transaction.pipedrive?.case === 'Error')
        );
        break;
      default:
        setFilterTransactions(transactions);
        break;
    }
  };

  const columns = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'date', headerName: 'Data', width: 120, sortable: false },
    { field: 'customer', headerName: 'Cliente', width: 300, sortable: false },
    { field: 'email', headerName: 'E-mail', width: 300, sortable: true },
    {
      field: 'product',
      headerName: 'Produto',
      sortable: false,
      width: 200
    },
    {
      field: 'subscription',
      headerName: 'Assinatura',
      sortable: false,
      width: 80
    },
    {
      field: 'paid',
      headerName: 'Valor',
      width: 160,
      sortable: true
    },
    { field: 'pipedrive', headerName: 'Ação', width: 200, sortable: false }
  ];

  const rows = filterTransactions
    .filter((transaction) => transaction.pipedrive_processed)
    .map((transaction, index) => {
      const { customer } = transaction;
      const date = moment(transaction.date_updated).format('D/MM/YY');
      const product = transaction.product?.name;
      const paid = `R$ ${parseFloat(transaction.paid).toFixed(2)}`;
      const pipedrive = transaction.pipedrive?.case;

      return {
        id: index + 1,
        date,
        customer: customer.name,
        email: customer.email,
        product,
        subscription: transaction.isSubscription ? 'sim' : '',
        paid,
        pipedrive
      };
    });

  return (
    <Page title="Transações | Pipedrive">
      <Container maxWidth="xl">
        <Box sx={{ pb: 5 }}>
          <Typography variant="h4" style={{ marginBottom: '10px' }}>
            Transações Pipedrive
          </Typography>
          {isLoading && <LinearProgress />}
        </Box>

        <Grid container spacing={3}>
          <Summary
            {...{
              totalPipedriveSuccess,
              totalNotSync,
              totalWithError,
              totalTransactions,
              isLoading,
              onSummaryClick
            }}
          />

          <Grid item xs={12}>
            <div style={{ height: 800, width: '100%' }}>
              <DataGrid rows={rows} columns={columns} pageSize={50} />
            </div>
          </Grid>
        </Grid>
      </Container>
    </Page>
  );
}
